import React from 'react';

import ExternalLink from 'components/generic/ExternalLink.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './NetworkSpeedChecker.module.scss';

const LINK_TERMS = 'https://www.getslick.com/legal/terms';

const SpeedFeedback = ({ speed, threshold }) => {
  const { t } = useTranslation();

  if (speed === 0) return null;

  return speed < threshold ? (
    <div className={CN.text}>
      {t('staffAndBusiness.userNetwork.hardwareInformation.speedFeedbackText1')}{' '}
      <ExternalLink variant="inline" link={LINK_TERMS}>
        <div className={CN.linkText}>{t('staffAndBusiness.userNetwork.termsAndConditions')}</div>
      </ExternalLink>
    </div>
  ) : (
    <div className={CN.text}>{t('staffAndBusiness.userNetwork.hardwareInformation.speedFeedbackText2')}</div>
  );
};

export default SpeedFeedback;
